import { FC, ReactNode } from "react";

interface IItineraryPanelProps {
    title?: string;
    footer?: ReactNode;
}

const ItineraryPanel: FC<IItineraryPanelProps> = (props) => {
    const { title, footer, children } = props;

    return (
        <div className="itinerary-panel">
            <div className="itinerary-panel-header">
                {title}
            </div>
            <div className={`itinerary-panel-body${footer ? " itinerary-panel-body-contains-footer" : ""}`}>
                {children}
            </div>
            {
                footer ?
                    <div className="itinerary-panel-footer">
                        {footer}
                    </div>
                    : ""
            }

        </div>
    )
}

export default ItineraryPanel;